export const isLastMessageContainFileUrl = (messages) => {
    if (!messages || messages.length === 0) return false;
    const lastMessage = messages[messages.length - 1];
    return lastMessage && lastMessage.role === "ai" && lastMessage.fileUrl ? true : false;
};